import * as AvatarPrimitive from '@radix-ui/react-avatar';
import React__default from 'react';
import { StyledAvatar } from './styles.js';
import { getInitials } from './utils.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const AvatarComponent = React__default.forwardRef(({
  name,
  src,
  size = 'md',
  displayInitials,
  delayMs = 300,
  onLoadingStatusChange,
  backgroundColor,
  contentColor,
  testId,
  ...props
}, ref) => {
  const initials = jsx("abbr", {
    "data-testid": testId && `${testId}-initials`,
    children: getInitials(name)
  });
  return jsx(StyledAvatar, {
    asChild: true,
    size: size,
    backgroundColor: backgroundColor,
    contentColor: contentColor,
    children: jsxs("div", {
      title: name,
      ref: ref,
      "data-testid": testId,
      ...props,
      children: [displayInitials || !src ? initials : jsx(AvatarPrimitive.Fallback, {
        asChild: true,
        delayMs: delayMs,
        children: initials
      }), src && jsx(AvatarPrimitive.Image, {
        onLoadingStatusChange: onLoadingStatusChange,
        src: src,
        alt: name,
        "data-testid": testId && `${testId}-image`
      })]
    })
  });
});
const Avatar = AvatarComponent;

export { Avatar };
